import { connect } from "react-redux";
import { Action, Dispatch } from "redux";

import { applicantKeyEventSessionDuplicatedAction } from "@actions/ApplicantAction";

import { RootState } from "@reducers/index";

import { KeyEventHandler, ExternalProps } from "./KeyEventHandler";

const mapStateToProps = (state: RootState, props: ExternalProps) => {
  const { challengeContext } = state.applicant;

  return {
    keyEventToken: challengeContext?.keyEventToken,
    challengeStorageId: challengeContext?.activeKeyEventLog?.storageId,
    challengeResultHistoryId: challengeContext?.challengeResultHistoryId,
    extensionId: challengeContext?.activeKeyEventLog?.extensionId,
    exam: state.applicant.exam,
    timer: state.applicantTimer.exam,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
  sessionDuplicate: () => {
    dispatch(applicantKeyEventSessionDuplicatedAction.request());
  },
});

/**
 * Wrapped component
 */
const wrappedComponent = connect(
  mapStateToProps,
  mapDispatchToProps,
)(KeyEventHandler);

export default wrappedComponent;
